import { useContext } from "react";

import { useMutation } from "@apollo/client/react";

import { LoginDocument, type LoginInput } from "@app_schema";

import { identify } from "@application/utilities/identify";

import { World } from "@application/contexts/world";

export const useLogin = () => {
  const [submit, { loading, data }] = useMutation(LoginDocument);
  const errors = data?.login.errors;

  const { login } = useContext(World);

  return {
    login: async (input: LoginInput) => {
      if (loading) return;
      const result = await submit({ variables: { input } });
      const ssoPath = result.data?.login.ssoPath;
      if (ssoPath) {
        window.location.assign(ssoPath);
        return;
      }
      const user = result.data?.login.user;
      if (user) {
        login();
        identify(user);
      } else if (typeof turnstile !== "undefined") {
        turnstile?.reset();
      }
    },
    loading,
    errors,
  };
};
